import * as Types from '../../../__generated__/api/types';

import gql from '@tv2-player/unifiedplayer/gqlToString';
import { StartOverInformationFragment } from './StartOver';
export type PlayUnifiedLiveEpgQueryVariables = Types.Exact<{
  guid: Types.Scalars['String']['input'];
  includeStartOverInformation: Types.Scalars['Boolean']['input'];
}>;

export type PlayUnifiedLiveEpgQuery = {
  entity:
    | {
        __typename: 'Broadcast';
        type: Types.EntityType | null;
        epgEntries: {
          __typename: 'EpgList';
          nodes: Array<{
            __typename: 'Epg';
            start: number | null;
            stop: number | null;
            title: string | null;
            entityId: string | null;
            startOverAvailable: boolean;
            vodAvailableStart: number | null;
            vodAvailableStop: number | null;
            transmissionId: string | null;
            imageUrl: string | null;
            entity:
              | {
                  __typename: 'Broadcast';
                  presentationTitle: string | null;
                  guid: string;
                  references: { __typename: 'References'; web: string; guid: string };
                }
              | {
                  __typename: 'Episode';
                  presentationTitle: string | null;
                  guid: string;
                  references: { __typename: 'References'; web: string; guid: string };
                }
              | {
                  __typename: 'Event';
                  presentationTitle: string | null;
                  guid: string;
                  references: { __typename: 'References'; web: string; guid: string };
                }
              | {
                  __typename: 'Movie';
                  presentationTitle: string | null;
                  guid: string;
                  references: { __typename: 'References'; web: string; guid: string };
                }
              | {
                  __typename: 'Program';
                  presentationTitle: string | null;
                  guid: string;
                  references: { __typename: 'References'; web: string; guid: string };
                }
              | {
                  __typename: 'Series';
                  presentationTitle: string | null;
                  guid: string;
                  references: { __typename: 'References'; web: string; guid: string };
                }
              | {
                  __typename: 'SportingEvent';
                  presentationTitle: string | null;
                  guid: string;
                  references: { __typename: 'References'; web: string; guid: string };
                }
              | {
                  __typename: 'Station';
                  presentationTitle: string | null;
                  guid: string;
                  references: { __typename: 'References'; web: string; guid: string };
                }
              | null;
            subPrograms?: Array<{
              __typename: 'Epg';
              entityId: string | null;
              title: string | null;
              start: number | null;
              stop: number | null;
              startOverAvailable: boolean;
              vodAvailableStart: number | null;
              vodAvailableStop: number | null;
              transmissionId: string | null;
              imageUrl: string | null;
              entity:
                | { __typename: 'Broadcast'; guid: string }
                | { __typename: 'Episode'; guid: string }
                | { __typename: 'Event'; guid: string }
                | { __typename: 'Movie'; guid: string }
                | { __typename: 'Program'; guid: string }
                | { __typename: 'Series'; guid: string }
                | { __typename: 'SportingEvent'; guid: string }
                | { __typename: 'Station'; guid: string }
                | null;
            } | null> | null;
          } | null> | null;
        } | null;
      }
    | { __typename: 'Episode'; type: Types.EntityType | null }
    | { __typename: 'Event'; type: Types.EntityType | null }
    | { __typename: 'Movie'; type: Types.EntityType | null }
    | { __typename: 'Program'; type: Types.EntityType | null }
    | { __typename: 'Series'; type: Types.EntityType | null }
    | { __typename: 'SportingEvent'; type: Types.EntityType | null }
    | { __typename: 'Station'; type: Types.EntityType | null }
    | null;
};

export type EpgFragment = {
  __typename: 'EpgList';
  nodes: Array<{
    __typename: 'Epg';
    start: number | null;
    stop: number | null;
    title: string | null;
    entityId: string | null;
    startOverAvailable: boolean;
    vodAvailableStart: number | null;
    vodAvailableStop: number | null;
    transmissionId: string | null;
    imageUrl: string | null;
    entity:
      | {
          __typename: 'Broadcast';
          presentationTitle: string | null;
          guid: string;
          references: { __typename: 'References'; web: string; guid: string };
        }
      | {
          __typename: 'Episode';
          presentationTitle: string | null;
          guid: string;
          references: { __typename: 'References'; web: string; guid: string };
        }
      | {
          __typename: 'Event';
          presentationTitle: string | null;
          guid: string;
          references: { __typename: 'References'; web: string; guid: string };
        }
      | {
          __typename: 'Movie';
          presentationTitle: string | null;
          guid: string;
          references: { __typename: 'References'; web: string; guid: string };
        }
      | {
          __typename: 'Program';
          presentationTitle: string | null;
          guid: string;
          references: { __typename: 'References'; web: string; guid: string };
        }
      | {
          __typename: 'Series';
          presentationTitle: string | null;
          guid: string;
          references: { __typename: 'References'; web: string; guid: string };
        }
      | {
          __typename: 'SportingEvent';
          presentationTitle: string | null;
          guid: string;
          references: { __typename: 'References'; web: string; guid: string };
        }
      | {
          __typename: 'Station';
          presentationTitle: string | null;
          guid: string;
          references: { __typename: 'References'; web: string; guid: string };
        }
      | null;
    subPrograms?: Array<{
      __typename: 'Epg';
      entityId: string | null;
      title: string | null;
      start: number | null;
      stop: number | null;
      startOverAvailable: boolean;
      vodAvailableStart: number | null;
      vodAvailableStop: number | null;
      transmissionId: string | null;
      imageUrl: string | null;
      entity:
        | { __typename: 'Broadcast'; guid: string }
        | { __typename: 'Episode'; guid: string }
        | { __typename: 'Event'; guid: string }
        | { __typename: 'Movie'; guid: string }
        | { __typename: 'Program'; guid: string }
        | { __typename: 'Series'; guid: string }
        | { __typename: 'SportingEvent'; guid: string }
        | { __typename: 'Station'; guid: string }
        | null;
    } | null> | null;
  } | null> | null;
};

export const EpgFragment = gql`
  fragment epgFragment on EpgList {
    nodes {
      ...startOverInformationFragment @include(if: $includeStartOverInformation)
      start
      stop
      title
      entity {
        presentationTitle
        references {
          web
          guid
        }
      }
      subPrograms @include(if: $includeStartOverInformation) {
        ...startOverInformationFragment
      }
    }
  }
`;
export const PlayUnifiedLiveEpg = gql`
  query play_unified_live_epg($guid: String!, $includeStartOverInformation: Boolean!) {
    entity(guid: $guid) {
      __typename
      type
      ... on Broadcast {
        epgEntries(limit: 2) {
          ...epgFragment
        }
      }
    }
  }
  ${EpgFragment}
  ${StartOverInformationFragment}
`;
